import React, { useRef, useState } from "react";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import Loading from "../../cross/Loading";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import { ROW_COUNT, ROW_COUNT_MAX } from "../../helpers/variableHelper";
import { ITipo_Campo } from "../../helpers/IFormHelper";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { AdminListaPagination, IPagination } from "../../controls/AdminListaPagination";
import LIOService from "../../services/LIOService";
import { IGestionLIO, ISearchGestionLIO } from "../../entities/IInspeccionObservacion";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import RenderTitle from "../../controls/RenderTitle";
import RenderValue from "../../controls/RenderValue";

const MySwal = withReactContent(Swal);
interface IGestionarLIOTest {
  items?: Array<IGestionLIO>;
  busqueda?: boolean;
}
export default function GestionarLIO({ items, busqueda }: IGestionarLIOTest) {
  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isLoading, setIsLoading] = useState(true);
  //
  const refNroLio = React.createRef<HTMLInputElement>();
  const totalPageListDesviaciones = useRef<number>(0);
  const [listAspecto, setListAspecto] = useState<Array<IGestionLIO>>(items || []);
  const [busquedaInicial, setBusquedaInicial] = useState(busqueda || false);
  let paramsActive = {
    PAGINA: 1,
    PAGINADO: ROW_COUNT_MAX,
    ORDENADOPOR: "ID",
    ORIENTACION: "ASC",
    ACTIVO: true,
  };
  console.log(isLoading);

  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentVerificarCierre = (info: any) => {
    return <div>
      <i
        data-testid="test1"
        className="bi bi-search iconSearch"
        title="Verificar Cierre"
        onClick={() => {
          window.location.href = `/agregarLIO?id=${info.getValue()}&idAspecto=${info.row.original.ID_ASPECTO_EVALUAR}`;
        }}></i>
    </div>
  };

  usePromiseEffect(async () => {
    setIsLoading(false);
    let token = await cognitoUserToken();
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
  }, []);

  const handleValidacionBusqueda = () => {
    let arrErrors = [];
    if (!refNroLio.current?.value) {
      arrErrors.push("Debe ingresar el número del correlativo.");
    } else if (isNaN(parseInt(refNroLio.current?.value || ""))) {
      arrErrors.push("Debe ingresar un número válido.");
    }
    if (arrErrors.length > 0) {
      MySwal.fire({
        html: (
          <div>
            <h3>Favor seleccione lo siguiente:</h3>
            {
              arrErrors.map((e) => (
                <p key={e}>{e}</p>
              ))
            }
          </div>
        ),
        icon: "warning",
        confirmButtonText: "Aceptar",
        showCloseButton: true,
        showCancelButton: false,
      });

      return false;
    }
    return true;
  };
  const handleBuscar = async (pagination?: IPagination) => {
    let defaultPagination = pagination || paramsActive;
    let paramsBusqueda: ISearchGestionLIO = {
      ...defaultPagination,

      NUMERO_INSPECCION: parseInt(refNroLio.current?.value || ""),
      CONTRATISTA_SUBCONTRATISTA: currentUser?.email as string,
    };
    if (handleValidacionBusqueda()) {
      let result = await LIOService.getGestionLIO(token, {
        ...paramsBusqueda,
      });
      setListAspecto(result.data);
      totalPageListDesviaciones.current = result.pages;
      setBusquedaInicial(true);
    }
    setIsLoading(false);
  };

  const handleLimpiarCampos = () => {
    (refNroLio.current as HTMLInputElement).value = "";
  };

  const columnHelperAspectoGestion = createColumnHelper<IGestionLIO>();
  let columnsDefAspectoGestion = [
    columnHelperAspectoGestion.accessor((row) => row.NUMERO_LISTA, {
      id: "NUMERO_LISTA",
      cell: (
        info: CellContext<IGestionLIO, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("Número Lista"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperAspectoGestion.accessor((row) => row.NUMERO_ASPECTO, {
      id: "NUMERO_ASPECTO",
      cell: (
        info: CellContext<IGestionLIO, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("N Aspecto"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperAspectoGestion.accessor((row) => row.ASPECTO, {
      id: "ASPECTO",
      cell: (
        info: CellContext<IGestionLIO, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("Aspecto"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperAspectoGestion.accessor((row) => row.ACCION, {
      id: "ACCION",
      cell: (
        info: CellContext<IGestionLIO, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("Acción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperAspectoGestion.accessor((row) => row.ESTADO, {
      id: "ESTADO",
      cell: (
        info: CellContext<IGestionLIO, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("Estado"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperAspectoGestion.accessor((row) => row.RESPONSABLE_ACCION, {
      id: "RESPONSABLE_ACCION",
      cell: (
        info: CellContext<IGestionLIO, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("Responsable Acción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperAspectoGestion.accessor((row) => row.ACCION_REALIZADA_POR_DISPLAY, {
      id: "ACCION_REALIZADA_POR_DISPLAY",
      cell: (
        info: CellContext<IGestionLIO, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("Acción Realizada Por"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperAspectoGestion.accessor((row) => row.ID_LIO, {
      id: "ID_ASPECTO_EVALUAR",
      cell: (//   
        info: CellContext<IGestionLIO, string>
      ) => (
        componentVerificarCierre(info)
      ),
      header: () => component("Verificar Cierre"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
  ] as any;

  return (
    <div className="row">
      <div className="col-12">
        <div className="rounded bg-white p-2 shadow">
          <div className="container-fluid mb-4">
            <h1 className="titPrincipal colorTit">LIO</h1>
            <div className="card bg-light border p-3 pt-2 mt-2">
              <div className="row ajusteInput">
                <h1 className="titPrincipal colorTit">Filtros</h1>
                <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                  <label className="text-sm">LIO:</label>
                  <input className="form-control form-control-sm" type="number" placeholder="Indique el número" ref={refNroLio} />
                </div>

                <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                  <button
                    type="button"
                    className="btn btn-sm btn-primary me-2"
                    onClick={() => {
                      setIsLoading(true);
                      handleBuscar();
                    }}>
                    {" "}
                    <i className="bi bi-search me-2"></i> Buscar
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary me-2"
                    onClick={() => {
                      handleLimpiarCampos();
                    }}>
                    {" "}
                    <i className="bi bi-trash me-2"></i>Limpiar Campos
                  </button>
                </div>
              </div>
            </div>

            <div className="" id="collapseGeneradas">
              <div className="card card-body border-0 p-0 mt-2">
                <div className="row">
                  <div className="col-12">
                    <div className="container-fluid mb-4">
                      <h1 className="titPrincipal colorTit mt-2"></h1>

                      <div className="row">
                        <div className="col-12">
                          {isLoading && <Loading></Loading>}
                          {busquedaInicial && (
                            <AdminListaPagination
                              defaultSortBy="ID"
                              sortDirection="ASC"
                              totalPages={totalPageListDesviaciones}
                              resultPerPage={ROW_COUNT}
                              callback={(pagination) => {
                                handleBuscar(pagination);
                              }}
                              data={listAspecto}
                              reload={() => {
                                handleBuscar();
                              }}
                              columnsDef={columnsDefAspectoGestion}
                              hideAdd={true}
                              hideExport={true}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
